export const toolNameMap: Record<string, string> = {
  knowledgeBase: "Knowledge Base",
  currentMedications: "Current Medications",
  medicationInfoForNdc: "Medication Info",
  basicDemographics: "Demographics",
  messages: "Messages",
  userTasks: "Tasks",
  observations: "Observations",
  labOrders: "Lab Orders",
  labOrderResults: "Lab Order Results",
  prescriptions: "Prescriptions",
  notes: "Notes",
  appointments: "Appointments",
  consultations: "Consultations",
  medicalConditions: "Medical Conditions",
  formularySheetInsuranceCoverage: "Insurance Coverage"
};

export const humanizeToolName = (name: string): string =>
  toolNameMap[name] ??
  name.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());

export const formatToolArgs = (
  args: Record<string, unknown> | undefined
): string => {
  if (!args) {
    return "";
  }
  const entries = Object.entries(args);
  if (entries.length === 0) {
    return "";
  }
  return entries.map(([k, v]) => `${k}: ${JSON.stringify(v)}`).join(", ");
};
